export default {
  submitClaimSectionTitle: {
    id: 'insurance_policy_details_submit_claim_section_title',
    defaultMessage: 'Issue with your device?',
  },
  helpSectionTitle: {
    id: 'insurance_policy_details_help_section_title',
    defaultMessage: 'How else can we help?',
  },
}
